import React from 'react';
import { AddCircle, Business, GitHub, Info, People, ShoppingCart, ViewList } from '@mui/icons-material';
import CustomMenu from '../layout/components/CustomMenu';
import useMenuItemClick from '../layout/hooks/useMenuItemClick';

const B2BUsersMenu = ({ handleLogout, onItemSelected = null }) => {
    const handleItemClick = useMenuItemClick(onItemSelected);

    const menuItems = [
        {
            label: 'Organizations',
            icon: <Business />,
            items: [
                {
                    label: 'List current organizations.',
                    icon: <ViewList />,
                    onClick: () => {
                        handleItemClick('/users/organizations');
                    },
                },
                {
                    label: 'Add new organization.',
                    icon: <AddCircle />,
                    rolesAllowed: ['ROLE_SUPER_ADMIN'],
                    onClick: () => {
                        handleItemClick('/users/newOrganization');
                    },
                },
            ],
        },
        {
            label: 'Users',
            icon: <People />,
            items: [
                {
                    label: 'List platform users.',
                    icon: <ViewList />,
                    onClick: () => {
                        handleItemClick('/users/users');
                    },
                },
                {
                    label: 'Add new user.',
                    icon: <AddCircle />,
                    onClick: () => {
                        handleItemClick('/users/newUser');
                    },
                },
            ],
        },
        {
            label: 'Products',
            icon: <ShoppingCart />,
            items: [
                {
                    label: 'List available products.',
                    icon: <ViewList />,
                    onClick: () => {
                        handleItemClick('/users/products');
                    },
                },
            ],
        },
        {
            label: 'Git Info',
            icon: <GitHub />,
            items: [
                {
                    label: 'Show GIT commit info.',
                    icon: <Info />,
                    onClick: () => {
                        handleItemClick('/users/git-info');
                    },
                },
            ],
        },
    ];

    return (
        <CustomMenu title="Users Menu"
            rolesAllowed={['ROLE_SUPER_ADMIN']}
            menuItems={menuItems} />
    );
};

export default B2BUsersMenu;